



















































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'CampaignBrowseOpportunitiesSearchCriteria' })
export default class extends GiganautVueDialog {
  public dialog = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (val) {
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }
      if (AgencySettingsModule.agencyUsers.length === 0) {
        await AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.locationTypes.length === 0) {
        await AgencySettingsModule.getLocationTypes();
      }
    }
  }

  get searchVM() {
    return CampaignDetailsModule.opportunitySearchViewModel;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get desks() {
    if (!this.searchVM.branchId) return [];
    const branch = AgencySettingsModule.branches.find((b: any) => b.id === this.searchVM.branchId);
    return branch ? branch.desks : [];
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get locationTypes() {
    return AgencySettingsModule.locationTypes;
  }

  get workTypeOptions() {
    return ListUtils.workTypes();
  }

  ownerLabel(item: any) {
    return item.person ? `${item.person.firstName} ${item.person.lastName}` : '';
  }

  onBranchChanged() {
    this.searchVM.deskId = null;
  }

  async search() {
    this.dialog = false;
    await CampaignDetailsModule.browseOpportunities();
  }
}
